import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { SubscriberGroupsSearchModel } from './types-store';
import { serializeCodes } from 'app/area/search-filters/serialize/serialize';

const serializeQuery = (query: string) =>
  query?.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};


export const serialize = (dataToSerialize: SerializePayload): SubscriberGroupsSearchModel => {

  const { query, formValues, menuValues, filters, filterValidation } = dataToSerialize;

  return {
    ...serializeQuery(query),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };
};
